const features = [
  {
    icon: "ri-shield-check-line",
    title: "官方认证入口",
    description: "提供禁漫天堂官方认证的最新访问入口与镜像站点，确保访问安全可靠，远离仿冒网站的风险。",
  },
  {
    icon: "ri-guide-line",
    title: "完整使用教程",
    description: "从注册登录到高级功能使用，涵盖禁漫天堂全部功能的详细教程，新手也能快速上手。",
  },
  {
    icon: "ri-grid-line",
    title: "内容分类导览",
    description: "全面介绍热血、恋爱、奇幻、搞笑、悬疑、科幻等各类型漫画分类，精准找到喜欢的作品。",
  },
  {
    icon: "ri-question-answer-line",
    title: "常见问题解答",
    description: "汇总用户最常遇到的问题及解决方案，包括访问、账号、阅读、下载等各方面的疑问。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端同步阅读",
    description: "支持PC端、移动端网页、Android APP和iOS APP，阅读进度和收藏数据云端实时同步。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新维护",
    description: "本指南页面持续更新，确保您获取的禁漫天堂入口信息和使用方法始终是最新版本。",
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            为什么选择我们的指南？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            我们致力于为禁漫天堂用户提供最全面、最及时的使用指南与入口导航服务
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-accent-300/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feat.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}